<template>
  <div class="collection-header" :style="collectionColor($props.colors)">
    <div class="collection-name">
      {{ $props.name }}
    </div>
    <div class="right-side-options">
      <div class="item-count">
        {{ $props.itemCount }} items
      </div>
      <div v-show="isDownloading && this.downloading === true">
        <circle-progress :is-bg-shadow="true" style="height:25px;width:25px;" :percent="percent" />
      </div>
      <div class="dl-collection" @click="handleDownload" :style="collectionColor($props.colors)">
        <div v-show="expanded" class="collection-download">
          Download Collection
        </div>
        <div class="dl-collection-arrow">
          <img v-show="!isDownloading" class="dl-collection-svg" :src="require('@/assets/svg/SVG/download.svg')"
            alt="Download Collection">

        </div>
      </div>
      <div class="collection-expand" @click="handleExpand" :style="collectionColor($props.colors)" :class="toggleHighlight">
        <div ref="expandArrow" class="expand-arrow">
          <img class="expand-collection-svg" :src="require('@/assets/svg/SVG/expand.svg')" alt="Expand Collection">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from 'gsap';
import { useRMTStore } from '@/store/RMTStore';
import { mapStores, storeToRefs } from 'pinia';
import { useResourceStore } from '@/store/ResourceStore';
import CircleProgress from 'vue3-circle-progress';
import { useCollectionStore } from '@/store/CollectionStore';

export default {
  name: 'CollectionsHeader',
  components: { CircleProgress },
  setup () {
    const RMTStore = useRMTStore();
    const { downloadCID } = storeToRefs(RMTStore);
    return {
      downloadCID
    };
  },
  data () {
    return {
      expanded: false,
      downloading: false
    };
  },
  computed: {
    ...mapStores(useRMTStore, useResourceStore, useCollectionStore),
    isDownloading () {
      return this.resourceStore.isDownloading;
    },
    percent () {
      return this.resourceStore.downloadPercent;
    },
    isSelected () {

      var collect = this.collectionStore.filteredCollections.filter((obj) => {
        return this.$props.cID === obj.cID;
      });
      if (collect.length > 0) {
        return collect[0].isSelected;
      }
      else { return false; }
    },
    toggleHighlight () {
      return (this.isSelected) ? 'collection-expanded' : '';
    }
  },
  props: [
    'name',
    'downloadUrl',
    'func',
    'cID',
    'itemCount',
    'colors'
  ],
  watch: {
    isDownloading (to) {
      // this collection has finished downloading
      if (!to) {
        this.downloading = false;
      }
    },
  },
  methods: {
    handleDownload (e) {
      e.stopImmediatePropagation();
      this.downloading = true;
      this.showDownloading = true;
      this.RMTStore.downloadCollectionZip(this.$props.cID);
    },
    setExpand (expand) {
      gsap.to(this.$refs.expandArrow, {
        rotation: (!this.expanded) ? 180 : 0,
        duration: 0,
        ease: 'power3.inOut'
      });

      this.expanded = expand;


    },
    handleExpand (e) {
      e.stopImmediatePropagation();
      this.$emit('expand');
    },
    collectionColor (color) {
      if (color === null) {
        return {
          'background-color': 'grey',
        };
      } else {
        return {
          'background-color': color
        };
      }
    }
  }
};
</script>
<style scoped>

.collection-header {
  height: 43px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: .8em;
  background-color: #f2f2f2;
  color: white;
  border: 1px solid black;
  margin-bottom: 8px;
}

.collection-name {
  margin: 5px 5px 5px 10px;
  font-weight: 700;
}

.collection-download {
  text-align: right;
  margin: 0px 0px 0px 10px;
  cursor: pointer;
  font-weight: 700;
  transition: background-color .2s;
}

/*.collection-download:hover {
  filter: brightness(0.9);
  transition: background-color .5s;
}*/

.collection-expand {
  width: 40px;
  border-left: 1px solid black;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.right-side-options {
  display: flex;
  justify-content: center;
  align-items: center;
}

.item-count {
  font-size: .9em;
  margin-right: 5px;
  transform: translateY(0px);
}

.dl-collection-svg {
  margin: 10px;
  width: 11px;
  transform: translateY(3px);
  filter: invert(1);
}

.collection-expand {
  align-self: stretch;
  transition: background-color .2s;
}

.collection-expanded,
.collection-expand:hover {
  filter: brightness(0.85);
  transition: background-color .2s;
}

.dl-collection {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.dl-collection:hover {
  filter: brightness(0.85);
  transition: background-color .2s;
}

.expand-arrow {
  width: 11px;
}

.expand-collection-svg {
  filter: invert(1);
}
</style>